import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  languageSelectionModalTitle: {
    id: 'unit-translation-selector-plugin.translationSelection.languageSelectionModalTitle',
    defaultMessage: 'Translate eligible course content',
    description: 'Title for the translation modal.',
  },
  originalLanguageLabel: {
    id: 'unit-translation-selector-plugin.translationSelection.originalCourseLanguage.label',
    defaultMessage: 'Original course language',
    description: 'Label for original course language list option',
  },
  cancelButtonText: {
    id: 'unit-translation-selector-plugin.translationSelection.cancelButtonText',
    defaultMessage: 'Cancel',
    description: 'Cancel button text for the translation modal.',
  },
  submitButtonText: {
    id: 'unit-translation-selector-plugin.translationSelection.submitButtonText',
    defaultMessage: 'Submit',
    description: 'Submit button text for the translation modal.',
  },
  upgradeButtonText: {
    id: 'unit-translation-selector-plugin.translationSelection.upgradeButtonText',
    defaultMessage: 'Upgrade for {upgradePrice}',
    description: 'Upgrade button text for the translation modal.',
  },
  poweredBy: {
    id: 'unit-translation-selector-plugin.translationSelection.poweredBy',
    defaultMessage: 'Powered by',
    description: 'Powered text for the translation modal.',
  },
  googleTranslateLogoAlt: {
    id: 'unit-translation-selector-plugin.translationSelection.googleTranslateLogoAlt',
    defaultMessage: 'Google translate logo',
    description: 'Alt text for the Google Translate logo.',
  },
  googleTranslateDisclaimer: {
    id: 'unit-translation-selector-plugin.translationSelection.googleTranslateDisclaimer',
    defaultMessage: 'This content has been translated using an AI-powered tool and may contain errors or inaccuracies.',
    description: 'Text for the translation modal.',
  },
  popoverDisclaimerTitle: {
    id: 'unit-translation-selector-plugin.translationSelection.popoverDisclaimerTitle',
    defaultMessage: 'Disclaimers',
    description: 'Disclaimer Popover Title',
  },
  popoverDisclaimerContent: {
    id: 'unit-translation-selector-plugin.translationSelection.popoverDisclaimerContent',
    defaultMessage: 'Eligible content includes most video transcripts, quizzes, and on platform text.',
    description: 'Line explaining the content to be translated in popover.',
  },
  popoverDisclaimerWarranties: {
    id: 'unit-translation-selector-plugin.translationSelection.popoverDisclaimerWarranties',
    defaultMessage: 'This service may contain translations provided by third parties, including artificial intelligence software/services. edX, its affiliates and licensors and the translation provider (the “Entities”) disclaim all warranties related to the translations. The translations are provided "as is" and the Entities disclaim all warranties whether express, implied, statutory or otherwise, including but not limited to any warranties of accuracy, reliability, merchantability, fitness for a particular purpose, satisfactory quality and non-infringement.',
    description: 'Line explaining the warranties in popover.',
  },
  additionalLanguageMissing: {
    id: 'unit-translation-selector-plugin.translationSelection.additonalLanguages',
    defaultMessage: 'Not seeing your preferred language? {surveyLink}',
    description: 'Text guiding user to survey link to suggest new translation languages',
  },
  surveyLinkLabel: {
    id: 'unit-translation-selector-plugin.translationSelection.additionalLanguages.link.label',
    defaultMessage: 'Tell us which one to add next.',
    description: 'text to describe the purpose of survey link',
  },
  upgradeLanguageSelectionModalTitle: {
    id: 'unit-translation-selector-plugin.translationSelection.upgrade.languageSelectionModalTitle',
    defaultMessage: 'Unlock eligible translations{asterisk}, certificate, and more',
    description: 'Title for the translation upgrade modal.',
  },
  upgradeLanguageSectionTitle: {
    id: 'unit-translation-selector-plugin.translationSelection.upgrade.languageSelectionTitle',
    defaultMessage: 'Gain access to high-quality translated content {tooltip}',
    description: 'Text for language selection section title',
  },
  upgradeLanguageSectionTooltip: {
    id: 'unit-translation-selector-plugin.translationSelection.upgrade.languageSelectionTitle.tooltip',
    defaultMessage: 'Eligible content currently includes: HTML/Text blocks, Video Transcripts, and Quiz/Problem Blocks',
    description: 'Text for language selection section title tooltip listing the content available for translation',
  },
  upgradeBenefitsSectionTitle: {
    id: 'unit-translation-selector-plugin.translationSelection.upgrade.moreBenefitsTitle',
    defaultMessage: 'More benefits of an upgrade',
    description: 'Text for more benefits of upgrade section title',
  },
  externalSiteLinkScreenreader: {
    id: 'ai-translations.link.external-site.screenreader-only.message',
    defaultMessage: 'external site, in a new tab',
    description: 'Screenreader only text for external site link',
  },
  newTabLinkScreenreader: {
    id: 'ai-translations.link.new-tab.screenreader-only.message',
    defaultMessage: 'in a new tab',
    description: 'Screenreader only text for new tab link',
  },
});

export default messages;
